import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PicUpload from "@/components/picUpload/index.vue";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { basicSetting } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
let BasicsSetting = class BasicsSetting extends Vue {
  constructor() {
    super(...arguments);
    this.postForm = {
      title: "",
      introduce: "",
      remark: "",
      hideIntro: "0",
      showTip: "0",
      popupText: "",
      leaveBtnText: "",
      cancelBtnText: "",
      coverUrl: "",
      showTipText: "确定要放弃填写吗？"
    };
    this.rules = {
      title: [{
        required: true,
        type: "string",
        validator: basicSetting.title,
        trigger: "blur"
      }],
      introduce: [{
        required: true,
        type: "string",
        validator: basicSetting.introduce,
        trigger: "blur"
      }],
      popupText: [{
        required: true,
        type: "string",
        validator: basicSetting.popupText,
        trigger: "blur"
      }],
      leaveBtnText: [{
        required: true,
        type: "string",
        validator: basicSetting.leaveBtnText,
        trigger: "blur"
      }],
      cancelBtnText: [{
        required: true,
        type: "string",
        validator: basicSetting.cancelBtnText,
        trigger: "blur"
      }],
      remark: [{
        required: false,
        type: "string",
        validator: basicSetting.remark,
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  async validate() {
    return await this.getFormInstance().validate(valid => {
      console.log("getFormInstance", valid);
      if (valid) {
        // alert("submit!");
        return true;
      } else {
        // console.log("error submit!!");
        return false;
      }
    });
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], BasicsSetting.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], BasicsSetting.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], BasicsSetting.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], BasicsSetting.prototype, "watchPostForm", null);
BasicsSetting = __decorate([Component({
  name: "basicsSetting",
  components: {
    PicUpload,
    questionSettingTemplate
  }
})], BasicsSetting);
export default BasicsSetting;